/*Create by BaiZhiming 2015-12-2*/
"use strict";
angular.module("copyBuildDraftModule", []).
controller("copyBuildDraftCtrl", ["$scope", "$element", "$timeout", '$modalInstance', "trsHttpService", "array", 'modalDialog', "methodname", function($scope, $element, $timeout, $modalInstance, trsHttpService, array, modalDialog, methodname) {
    initData();
    initStatus();
    $scope.confirm = function() {
        $scope.status.openBtn = false;
        angular.forEach($scope.draftArray, function(data, index, array) {
            $scope.draftArray[index].CHNLDOCID = parseInt($scope.draftArray[index].CHNLDOCID);
            if ($scope.draftArray[index].MEDIATYPES === undefined) {
                $scope.draftArray[index].MEDIATYPES = 0;
            } else {
                $scope.draftArray[index].MEDIATYPES = $scope.draftArray[index].MEDIATYPES;
            }
        });
        var params = {
            "methodname": methodname,
            "serviceid": "mlf_fusionmyrelease",
            "COPYDOCS": JSON.stringify(angular.copy($scope.draftArray))
        };
        $scope.loadingPromise = trsHttpService.httpServer("/wcm/mlfcenter.do", params, "post").then(function(data) {
            $scope.status.openBtn = true;
            // modalDialog.alertType("操作成功！", "操作成功！", "success", false, function() {});
            $modalInstance.close("success");
        }, function() {
            $scope.status.openBtn = true;
        });
    };
    /**
     * [handleDraftTitle description] 处理稿件标题中的html标签
     * @param  {[type]} draft [description] 稿件信息
     * @param  {[type]} attribute [description] 稿件属性
     * @return {[type]}       [description]
     */
    $scope.handleDraftTitle = function(draft, attribute) {
        let titleHtml = document.createElement('div');
        titleHtml.innerHTML = draft[attribute];
        draft[attribute] = titleHtml.innerText;
    };
    $scope.cancel = function() {
        $modalInstance.close("failed");
    };

    function initStatus() {
        $scope.status = {
            openBtn: true
        };
    }

    function initData() {
        trsHttpService.httpServer("./editingCenter/properties/iWoCopyBuildDraft.json", {}, "get").then(function(data) {
            $scope.MEDIATYPES = data.MEDIATYPES;
        }, function(data) {});
        $scope.draftArrayC = array;
        $scope.draftArray = [];
        angular.forEach($scope.draftArrayC, function(data, index, array) {
            $scope.draftArray.push({
                CHNLDOCID: data.CHNLDOCID,
                METADATAID: data.METADATAID,
                OLDTITLE: angular.isDefined(data.TITLE) ? data.TITLE : data.DOCTITLE,
                TITLE: angular.isDefined(data.TITLE) ? data.TITLE : data.DOCTITLE,
                MEDIATYPES: "0"
            });
        });
        $timeout(function() {
            $element.find("input")[0].focus();
        });
    }
}]);